import googleAnalyticsPlugin from 'top20common/distribution/services/analytics/google-analytics';

import events from '@/plugins/events';

export default function(multianalytics) {
  return {
    ...events(multianalytics),
    ...googleAnalyticsPlugin(multianalytics)
  };
}
